<template>
    <div class="cardContainer"
        :class="activityStatus == 1 ? 'claimCard' : activityStatus == 2 ? 'norewardCard' : activityStatus == 3 ? 'norewardCard' : activityStatus == 0 ? 'pendingCard' : ''">
        <div class="cardSubContainer">
            <div class="refund-card"
                :class="activityStatus == 1 ? 'refund-card' : activityStatus == 2 ? 'refund-card-2' : activityStatus == 3 ? 'refund-card-2' : activityStatus == 0 ? 'refund-card-1' : ''">
                <div class="check-badge"
                    :class="activityStatus == 1 ? 'check-badge' : activityStatus == 2 ? 'check-badge-2' : activityStatus == 3 ? 'check-badge-2' : activityStatus == 0 ? 'check-badge-1' : ''">
                    <van-icon v-if="activityStatus == 0" name="underway-o " color="#b8b2b2" />
                    <van-icon v-if="activityStatus == 1" name="success" />
                    <van-icon v-if="activityStatus == 2 || activityStatus == 3" name="cross" color="#ffadad" />
                </div>
                <div class="calendar-wrapper">
                    <img v-if="activityStatus == 0" src="@/assets/rechargeGift/blue_calender.png" width="75px"
                        style="border-radius: 10px;">
                    <img v-if="activityStatus == 1" src="@/assets/rechargeGift/green_calender.png" width="75px"
                        style="border-radius: 10px;">
                    <img v-if="activityStatus == 2 || activityStatus == 3" src="@/assets/rechargeGift/red_calender.png"
                        width="75px" style="border-radius: 10px;">
                    <div class="calendar">
                        <div class="cal-header">{{ year }}</div>
                        <div class="cal-body">
                            <span class="month">{{ month }}</span>
                            <span class="day">{{ day }}</span>
                        </div>
                    </div>
                </div>

                <div class="stats-section">
                    <div class="status-badge"
                        :class="activityStatus == 1 ? 'status-badge' : activityStatus == 2 ? 'status-badge-2' : activityStatus == 3 ? 'status-badge-2' : activityStatus == 0 ? 'status-badge-1' : ''">
                        <p v-if="props.activityStatus == 0" style="color: #0484ff;">{{
                            $t('activityStatus.pending') }}</p>
                        <p v-else-if="props.activityStatus == 1" style="color: #36d836;">{{
                            $t('activityStatus.completed')
                        }}</p>
                        <p v-else-if="props.activityStatus == 2" style="color: #ff0000;">{{
                            $t('activityStatus.noRewards')
                        }}</p>
                        <p v-else-if="props.activityStatus == 3" style="color: #ff0000;">{{ $t('activity.overdue')
                        }}</p>
                    </div>

                    <div class="stats-grid">
                        <van-row>
                            <van-col span="11">
                                <div class="stat-item">
                                    <p>{{ title }}</p>
                                    <span class="value yellow">{{ formatCurrency(totalAmount) }}<img
                                            src="@/assets/rechargeGift/coin.png" alt="" width="12%"
                                            style="padding-left: 5%;"></span>
                                </div>
                            </van-col>
                            <van-col span="1">
                                <div class="divider"></div>
                            </van-col>
                            <van-col span="11">
                                <div class="stat-item">
                                    <p>{{ $t('activity.cashBackTotal') }}</p>
                                    <span class="value yellow">{{ dayList ? formatCurrency(getAmountSum(dayList)) :
                                        formatCurrency(0) }}<img src="@/assets/rechargeGift/coin.png" alt="" width="12%"
                                            style="padding-left: 5%;"></span>
                                </div>
                            </van-col>
                        </van-row>

                    </div>
                </div>
            </div>

        </div>

        <van-row v-if="!isShowDetails" :style="{ borderBottom: isShowDetails ? '#80808070 dashed 2px' : '' }">
            <van-col span="6" class="dayColumn">
                <div class="dayImage2">
                    <img src="@/assets/common/calender.png" alt="">
                    <div class="dateText" style="font-size: 12px;">{{ createTime?.split(' ')[0] }}
                    </div>
                </div>
            </van-col>
            <van-col span="12" class="topRow" style="margin: 10px 0;">
                <div class="dayTitle" style="font-size: 12px;">{{ $t('activity.givenAmount') }} : <span
                        style="padding-left: 10px;"> {{ formatCurrency(givenAmount) }}</span></div>
            </van-col>
            <van-col span="6" class="dayColumn">
                <span class="right-texts">
                    <p v-if="props.activityStatus == 0" style="color: #0484ff;">{{
                        $t('activityStatus.pending') }}</p>
                    <p v-else-if="props.activityStatus == 1" style="color: #36d836;">{{ $t('activityStatus.completed')
                    }}</p>
                    <p v-else-if="props.activityStatus == 2" style="color: #ff0000;">{{ $t('activityStatus.noRewards')
                    }}</p>
                    <p v-else-if="props.activityStatus == 3" style="color: #ff0000;">{{ $t('activity.overdue')
                    }}</p>
                </span>
            </van-col>
        </van-row>
        <van-row  style=" display: flex; justify-content: center; padding-bottom:10px"
            justify="space-between">
            <van-col v-if="dayList && dayList?.length > 0" span="24"
                style="display: flex; justify-content: center; align-items: center; color: #c0aae7bd;padding-bottom:10px">
                <div class="line"></div>
                <div>DETALHES DO REEMBOLSO</div>
                <div class="line"></div>
            </van-col>
            <van-col span="4" v-for="(i, index) in dayList" :key="index">
                <div class="dayCard">
                    <div class="dayTitle">{{ (dayFormat(i.date, 0)) }}</div>
                    <div
                        :style="{ color: activityStatus == 1 ? '#36d8368a' : activityStatus == 2 || activityStatus == 3 ? '#dc3d3d8a' : activityStatus == 0 ? '#3d9edc8a' : '' }">
                        {{ formatCurrency(i.amount) }}</div>
                </div>
            </van-col>
        </van-row>
    </div>
</template>
<script lang="ts" setup>
import { checkDate, dayFormat, formatCurrency, } from '@/utils/commonFunction';
import { getAmountSum } from '@/view/components/supportFunction';
import { computed, PropType, ref, } from 'vue';

const props = defineProps({
    dayCount: {
        type: Number,
    },
    dayList: {
        type: Array as PropType<(any)[]>,
        default: () => []
    },
    createTime: {
        type: String,
        default: () => ""
    },
    availableAmount: {
        type: Number,
        default: () => 0
    },
    title: {
        type: String,
        default: () => ""
    },
    totalAmount: {
        type: Number,
        default: () => 0
    },
    activityStatus: {
        type: Number
    },
    istodayClaimed: {
        type: Boolean,
        default: () => false
    },
    isShowDetails: {
        type: Boolean,
        default: () => true
    },
    givenAmount: {
        type: Number,
        default: () => 0
    },
})
const dateObj = computed(() => {
    if (!props.createTime) return new Date();
    const dateString = props.createTime;
    return new Date(dateString);
});

const year = computed(() => dateObj.value.getFullYear());
const day = computed(() => dateObj.value.getDate());
const month = computed(() => dateObj.value.toLocaleString('en-US', { month: 'long' }));
</script>
<style scoped>
.cardContainer {
    background: #292a2d;
    border: 2px solid #ffcea6;
    border-radius: 10px;
    padding: 0 10px;
    color: #fff;
    font-size: 12px;
    margin: 10px 0 0;
    font-family: 'Roboto';
}

.claimCard {
    background: linear-gradient(180deg, #142111 0%, #0a0f08 100%);
    border: 1px solid #2a3d24;
}

.pendingCard {
    background: linear-gradient(180deg, #121121 0%, #08080f 100%);
    border: 1px solid #24293d;
}

.norewardCard {
    background: linear-gradient(180deg, #211111 0%, #0f0808 100%);
    border: 1px solid #3d2424;
}

.refund-card {
    position: relative;
    overflow: hidden;
    border-radius: 8px;
    display: flex;
    padding: 15px 15px 10px;
    color: #fff;
    gap: 20px;
    border-left: 2px solid;
    border-image: linear-gradient(180deg, transparent 5%, #3e8b2d 25%, transparent 50%) 1;
}

.refund-card::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, #26790a 0%, #167c2b 25%, #348918 45%, transparent 50%);
    z-index: 1;
}

.refund-card-1 {
    border-left: 2px solid;
    border-image: linear-gradient(180deg, transparent 5%, #2d3a8b 25%, transparent 50%) 1;
}

.refund-card-1::before {
    background: linear-gradient(135deg, #042c90 0%, #162f7c 25%, #183289 45%, transparent 50%);
}

.refund-card-2 {
    border-left: 2px solid;
    border-image: linear-gradient(180deg, transparent 5%, #8b2d2d 25%, transparent 50%) 1;
}

.refund-card-2::before {
    background: linear-gradient(135deg, #790a0a 0%, #7c1616 25%, #891818 45%, transparent 50%);
}

.calendar-wrapper {
    position: relative;
    z-index: 2;
    margin-left: 5%;
}

.check-badge {
    position: absolute;
    top: 5px;
    left: 5px;
    background: radial-gradient(circle, rgb(69 180 49) 0%, rgb(4 66 3) 100%);
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    z-index: 2;
    border: 3px solid #22ba00;
}

.check-badge-1 {
    border: 3px solid #0048ba;
    background: radial-gradient(circle, rgb(49 136 180) 0%, rgb(3, 7, 66) 100%);
}

.check-badge-2 {
    border: 3px solid #ba0000;
    background: radial-gradient(circle, rgb(180, 49, 49) 0%, rgb(66, 3, 3) 100%);
}

.calendar {
    position: absolute;
    top: 5px;
    width: 75px;
    border-radius: 6px;
    overflow: hidden;
    text-align: center;
}

.cal-header {
    color: white;
    font-size: 12px;
    padding: 2px 0;
    font-weight: bold;
}

.cal-body {
    color: #333;
    padding: 5px 0;
}

.cal-body .month {
    display: block;
    font-size: 11px;
    padding-top: 5%;
    font-weight: bold;
    color: #666;
    text-transform: uppercase;
}

.cal-body .day {
    padding-top: 5%;
    display: block;
    font-size: 28px;
    font-weight: bold;
    line-height: 1;
}

.cal-body .weekday {
    font-size: 10px;
    color: #666;
}

.stats-section {
    width: 100%;
}

.status-badge {
    background: #1a2e16;
    color: #4caf50;
    border: 1px solid #2a4d21;
    font-size: 11px;
    padding: 4px 12px;
    border-radius: 4px;
    width: fit-content;
    margin-bottom: 15px;
}

.status-badge-1 {
    background: #16172e;
    color: #4e4caf;
    border: 1px solid #21244d;
}

.status-badge-2 {
    background: #2e1616;
    color: #af4c4c;
    border: 1px solid #4d2121;
}

.status-badge p {
    margin: 0px;
    text-transform: uppercase;
}

/* .stats-grid {
    display: flex;
    align-items: center;
    gap: 15px;
} */
.stat-item {
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.stat-item p {
    font-size: 12px;
    color: #c0aae7bd;
    margin: 0 0 5px 0;
    text-align: center;
}

.stat-item .value {
    font-size: 16px;
    font-weight: bold;
    color: #e3b453;
    text-align: center;
}

.divider {
    width: 1px;
    height: 30px;
    background: #c0aae77d;
    margin-top: 15px;
}

/* 3. Right Grid Section */
.details-section {
    flex-grow: 1;
    border-left: 1px solid #333;
    padding-left: 20px;
}

.section-title {
    font-size: 10px;
    color: #666;
    text-align: right;
    margin-bottom: 10px;
}

.details-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1px;
    /* Creates the internal lines */
    background: #222;
    /* Line color */
    border: 1px solid #222;
}

.grid-item {
    background: #0d140b;
    /* Item background */
    padding: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.grid-item .date {
    font-size: 9px;
    color: #888;
    text-transform: uppercase;
}

.grid-item .amount {
    font-size: 12px;
    font-weight: bold;
    color: #4caf50;
}

.grid-item.highlight .amount {
    color: #66bb6a;
}

.grid-item.high-value .amount {
    color: #a5d6a7;
    font-size: 14px;
}

.grid-item.more {
    justify-content: center;
    color: #666;
    cursor: pointer;
}

.topRow {
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.dayColumn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
}

.right-texts {
    text-align: center;
    display: flex;
}

.day-num {
    position: absolute;
    font-size: 20px;
    white-space: nowrap;
    color: #FFF5D7;
    text-shadow: -1px -1px 0 #300000, 1px -1px 0 #300000, -1px 1px 0 #300000, 1px 1px 0 #300000;
    z-index: 800;
    font-weight: 700;
    left: 55%;
    top: 25%;
}

.dateText {
    position: absolute;
    top: 50%;
    padding: 5px 0;
    font-size: 6px;
    color: #000;
    font-weight: 600;
}

.dayImage img {
    width: 80%;
    padding: 0 0 5px;
    position: relative;
}

.dayImage {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.dayImage2 img {
    width: 75px;
    height: 50px;
    position: relative;
}

.dayImage2 {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.centerAlignment {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
}

.line {
    width: 15%;
    background: #c0aae737;
    height: 1px;
    margin: 5px;
}

.dayCard {
    color: #ffffffac;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 5px 0;
    min-width: 13%;
    flex-shrink: 0;
    border: 1px solid #6161611b;
}

.dayCardWrapper {
    display: flex;
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: none;
    -ms-overflow-style: none;
    flex: 1;
}

.dayCardWrapper::-webkit-scrollbar {
    display: none;
}

.scrollRow {
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
    gap: 5px;
}

.arrowLeft img {
    width: 10px;
}

.arrowRight {
    position: absolute;
    right: 0px;
}

.arrowLeft {
    position: absolute;
    left: 0px;
}

.arrowRight img {
    width: 10px;
    transform: rotate(180deg);
}

.dayTitle {
    font-weight: bold;
    padding-bottom: 5px;
}

.rightBorder {
    border-right: 1px solid #80808070;
}

.click_btn {
    color: #12151A;
    font-size: 11.5px;
    background-image: linear-gradient(rgb(248, 216, 167) 0%, rgb(240, 168, 83) 100%);
    border-radius: 5px;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    display: flex;
    text-align: center;
    justify-content: center;
    width: 50%;
}

.valueText {
    padding: 2px 0 5px;
}

.bottomDayRow {
    display: flex;
    flex-direction: row;
}

@media (min-width:350px) {
    .dateText {
        font-size: 8px;
    }
}

@media (min-width:450px) {
    .dateText {
        font-size: 11px;
    }
}

@media (min-width: 600px) {
    .dateText {
        font-size: 10px;
    }
}

@media (min-width: 1920px) {
    .dateText {
        font-size: 14px;
    }
}
</style>